<template>
  <div>
    <div class="modal-overlay" @click.self="closeTransactionVolumesModal">

      <div class="modal-content">
        <header>
          <p :style="`color: #10233E; font-size: 16px; font-weight: 600; margin-bottom: 2%;`">Transaction Volumes</p>
        </header>

        <table class="pay-history-cover responsive-table  border-collapse w-full mt-2">
          <thead class="" v-for="(payH, index) in payHistory" :key="index">
            <tr class="pay-history">
              <th :style="`color: #ACACAC; font-size: 12px; font-weight: 600; width: 5%; text-align: center;`">
                {{ payH.counts }}</th>
              <th :style="`padding-left: 3%; color: #232323; font-size: 12px; font-weight: 700; width: 35%;`">
                {{ payH.terminals }}</th>
              <th :style="`color: #232323; font-size: 12px; font-weight: 700; `">{{ payH.amount }}</th>
              <th :style="`color: #232323; font-size: 12px; font-weight: 700; text-align: center;`">
                {{ payH.transactionsCount }}</th>
            </tr>
          </thead>
          <tbody >
            <tr class="pay-history volumes-content" v-for="(tabdet, index) in dataList" :key="index">
              <td :style="` color: #232323; font-size: 12px; font-weight: 400; `">{{ index + 1 }}</td>
              <td :style="` color: #10233E; font-size: 12px; font-weight: 400; `">{{ tabdet.name }}</td>
              <td :style="`padding-left: 1%; color: #10233E; font-size: 12px; font-weight: 400; `">
                {{ tabdet.amount }}
              </td>
              <td :style="`padding-left: 8%; color: #10233E; font-size: 12px; font-weight: 400;`">
                {{ tabdet.count }}
              </td>
            </tr>
            <tr class="pay-history">
              <td>{{ "" }}</td>
              <td :style="`color: #10233E; font-size: 12px; font-weight: 600;`">Total</td>
              <td :style="`padding-left: 1%; color: #10233E; font-size: 12px; font-weight: 700;`">₦ {{ totalValue }}</td>
              <td :style="`padding-left: 8%; color: #10233E; font-size: 12px; font-weight: 700;`">{{ totalCount }}</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: { type: Object, required: true },
  },
  data() {
    return {
      payHistory: [
        { counts: "#", terminals: "Terminals", amount: "Amount", transactionsCount: "No. of Transactions" },
      ],
    };
  },

  computed: {
    totalValue() {
      return this.dataList?.totalAmount ?? 0;
    },
    totalCount() {
      return this.dataList?.totalCount ?? 0;
    },
  },

  methods: {
    closeTransactionVolumesModal() {
      this.$emit("close-TransactionVolumes-modal")
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  /* align-items: center; */
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 1rem;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  /* border: 1px solid red; */
}

.pay-history-cover {
  /* border: 1px solid yellow; */
}

.pay-history>th {
  /* border: 1px solid blue; */
}

.pay-history>td {
  /* border: 1px solid blue; */
}

.volumes-content:nth-child(even) {
  background: #F2F7FC;
}

</style>